import React from "react";
import { Modal, Button, Card } from "react-bootstrap";

const TransactionModal = ({ isOpen, onClose, data, referralCommissionTotal }) => {
  const paymentDetails = referralCommissionTotal?.[0]?.paymentDetails || [];

  return (
    <Modal show={isOpen} onHide={onClose} centered size="lg">
      <div className="modal-header">
        <h5 className="modal-title">Transaction Info</h5>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <h6 className="mt-4 mb-3">Payment History</h6>

        {/* Dynamic card rendering from Redux paymentDetails */}
        <div className="d-flex flex-column gap-3">
          {paymentDetails?.length > 0 ? (
            paymentDetails?.map((payment, index) => (
              <Card key={index} className="shadow-sm">
                <Card.Body className="d-flex flex-wrap justify-content-between align-items-center">
                  <div className="mb-2">
                    <strong>Transaction Date:</strong>{" "}
                    {payment?.appDate?.[0]
                      ? new Date(payment.appDate[0]).toLocaleDateString()
                      : "N/A"}
                  </div>
                  <div className="mb-2">
                    <strong>TransactionId:</strong>{" "}
                    {payment?.transactionId || "N/A"}
                  </div>
                  <div className="mb-2">
                    <strong>Paid Amount:</strong> ₹{payment?.totalPaidReferralAmount || 0}
                  </div>
                  {/* <div className="mb-2">
                    <Button size="sm" variant="outline-primary">
                      Print
                    </Button>
                  </div> */}
                </Card.Body>
              </Card>
            ))
          ) : (
            <div>No transaction history available.</div>
          )}
        </div>
      </div>

      <div className="modal-footer">
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default TransactionModal;
